import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { format } from "date-fns";
//primeReact
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { Divider } from "primereact/divider";
//components
import Input from "../../../input/Input";
import MaskInput from "../../../input/MaskInput";
import CalendarInput from "../../../input/CalendarInput";
import TextareaInput from "../../../input/TextareaInput";
//services
import { postCheckUser } from "../../../../services/GeneralRegistration/postCheckUser";
//utils
import { api } from "../../../../utils/api";

export function Spouse({
  errors,
  visible,
  control,
  onClose,
  setValue,
  getValues,
  setSpouse,
  editPartner,
  onChangeSpouse,
  inputRequireds,
}) {
  const [loading, setloading] = useState(false);
  const [isMaried, setIsMaried] = useState(false);
  const [typePartner, setTypePartner] = useState(false);
  const [foundPartner, setFoundPartner] = useState(editPartner ?? false);
  const [isEditing, setIsEditing] = useState(!!editPartner);
  const [lastFetchedDoc, setLastFetchedDoc] = useState(null);
  const cleanObject = (obj) => {
    return Object.fromEntries(
      Object.entries(obj).filter(
        ([_, v]) => v !== undefined && v !== null && v !== ""
      )
    );
  };

  useEffect(() => {
    // console.log("useEffect Spouse: visible =", visible, "editPartner =", editPartner);
    if (visible) {
      setIsEditing(!!editPartner);
      setFoundPartner(editPartner ?? false);
      setIsMaried(false);
      setTypePartner(false);
      setLastFetchedDoc(null);
    }
  }, [visible, editPartner]);
  const handleNext = async (data) => {
    if (data.number_conjuge) {
      const isValid = /\(\d{2}\)\s9/.test(data.number_conjuge);
      if (!isValid) {
        return toast.error("Celular inválido.");
      }
      if (data.contacts_conjuge === undefined) data.contacts_conjuge = [];

      data.contacts_conjuge.push({
        number: data.number_conjuge,
        type_number: 1,
        is_default: true,
      });
    }
    const notification = toast.loading("Por favor aguarde...");
    if (data.tel_conjuge) {
      //      console.log(data.tel_conjuge)
      if (data.contacts_conjuge === undefined) data.contacts_conjuge = [];

      data.contacts_conjuge.push({
        number: data.tel_conjuge,
        type_number: 2,
        is_default: false,
      });
    }

    const {
      name_conjuge,
      doc_conjuge,
      rg_conjuge,
      date_of_birth_conjuge,
      email_conjuge,
      profession_conjuge,
      name_mother_conjuge,
      name_father_conjuge,
      issuing_authority_conjuge,
      nationality_conjuge,
      obs_conjuge,
      contacts_conjuge,
    } = data;

    const dateBirth = date_of_birth_conjuge
      ? format(date_of_birth_conjuge, "yyyy-MM-dd")
      : "";

    const infos = cleanObject({
      name: name_conjuge,
      doc: doc_conjuge,
      rg: rg_conjuge,
      date_of_birth: dateBirth,
      email: email_conjuge,
      profession: profession_conjuge,
      name_mother: name_mother_conjuge,
      name_father: name_father_conjuge,
      issuing_authority: issuing_authority_conjuge,
      nationality: nationality_conjuge,
      obs: obs_conjuge,
      type_doc: 1,
      registration_types: [2],
      contacts: contacts_conjuge,
    });

    //    console.log(infos)

    try {
      setloading(true);
      const response = await api.post("register-general", infos);

      toast.update(notification, {
        render: response.data.success,
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
      //      console.log(response.data);

      setSpouse(response.data.data);
      setValue(`spouse_id`, response.data.data.id);
      onChangeSpouse && onChangeSpouse(response.data.data);
      onClose();
    } catch (e) {
      //      console.log(e);
      setloading(false);

      toast.update(notification, {
        render: "Falha ao executar a ação!",
        autoClose: 5000,
        type: "error",
        theme: "colored",
        isLoading: false,
      });
    } finally {
      setloading(false);
    }
  };

  const fetchConjuge = async (doc) => {
    // console.log("fetchConjuge chamado com doc:", doc);
    const notification = toast.loading("Por favor aguarde a consulta...");
    const data = {
      doc: doc,
    };
    try {
      const response = await postCheckUser(data);
      // console.log("Resposta do postCheckUser:", response);
      if (response.married) {
        setIsMaried(true);
        setFoundPartner({
          id: response.user_id,
          doc: doc,
          name: response.user_name,
        });
        setValue(`name_conjuge`, response.user_name);

        setloading(false);
        toast.update(notification, {
          render: "Esse usuário não pode ser vinculado",
          autoClose: 5000,
          theme: "colored",
          type: "warning",
          isLoading: false,
        });
        return;
      }
      setIsMaried(false);
      setTypePartner(false);
      if (response.exists) {
        const hasPartner = response.type
          ? response.type.filter((i) => i.name === "Conjuge")
          : [];
        // console.log("hasPartner:", hasPartner);
        if (hasPartner.length === 0) {
          setTypePartner(true);
          setFoundPartner({
            id: response.user_id,
            doc: doc,
            name: response.user_name,
          });
          setValue(`name_conjuge`, response.user_name);
          setloading(false);
          toast.update(notification, {
            render: "Esse usuário não pode ser vinculado",
            autoClose: 5000,
            theme: "colored",
            type: "warning",
            isLoading: false,
          });
          return;
        }
        if (response.has_permission) {
          setFoundPartner({
            id: response.user_id,
            doc: doc,
            name: response.user_name,
          });
          setValue(`name_conjuge`, response.user_name);
        } else {
          toast.update(notification, {
            render:
              "Sem permissão para visualizar esse usuário, solicite o acesso com o Administrador",
            autoClose: 5000,
            theme: "colored",
            type: "warn",
            isLoading: false,
          });
        }
      } else {
        // console.log("CPF não existe, limpando campos");
        setFoundPartner(false);
        setValue(`name_conjuge`, "");
        setValue(`rg_conjuge`, "");
        setValue(`date_of_birth_conjuge`, "");
        setValue(`email_conjuge`, "");
        setValue(`profession_conjuge`, "");
        setValue(`tel_conjuge`, "");
        setValue(`number_conjuge`, "");
        setValue(`nationality_conjuge`, "");
        setValue(`name_mother_conjuge`, "");
        setValue(`name_father_conjuge`, "");
        setValue(`issuing_authority_conjuge`, "");
        setValue(`obs_conjuge`, "");
      }
      toast.update(notification, {
        render: "Consulta Realizada!",
        autoClose: 1000,
        theme: "colored",
        type: "success",
        isLoading: false,
      });
    } catch (error) {
      console.log("Erro no fetchConjuge:", error);
      toast.update(notification, {
        render: "CPF inválido.",
        type: "error",
        theme: "colored",
        autoClose: 5000,
        isLoading: false,
      });
    }
  };

  const handleLinkPartner = () => {
    setSpouse({
      id: foundPartner.id,
      doc: foundPartner.doc,
      name: foundPartner.name,
    });

    setValue(`spouse_id`, foundPartner.id);
    onChangeSpouse &&
    onClose();
  };

  return (
    <>
      <Dialog
        header="Cadastro do Cônjuge"
        className="rounded-4"
        visible={visible}
        onHide={onClose}
        style={{ width: "90vw" }}
        draggable={false}
        resizable={false}
      >
        <div>
          <Divider>
            <div className="inline-flex align-items-center">
              <i className="pi pi-user me-2"></i>
              <b>Informações Pessoais (Cônjuge)</b>
            </div>
          </Divider>
          {isMaried && (
            <div className="card p-3 bg-cyan-300 rounded-3 bg-opacity-75 my-2">
              <span className="text-blue-800">
                <i className="fa-solid fa-circle-info me-1"></i>
                <b>Atenção</b>: A Pessoa Selecionada Já é Cônjuge de Outro
                Usuário.
              </span>
            </div>
          )}
          {typePartner && (
            <div className="card p-3 bg-cyan-300 rounded-3 bg-opacity-75 my-2">
              <span className="text-blue-800">
                <i className="fa-solid fa-circle-info me-1"></i>
                <b>Atenção</b>: A Pessoa Selecionada Não Possui o Tipo de
                Cadastro Cônjuge.
              </span>
            </div>
          )}
          <div className="row px-3">
            <div className="col-md-3">
              <MaskInput
                control={control}
                errors={errors}
                isRequired={true}
                onComplete={(value) => {
                  // console.log("onComplete chamado com value:", value);
                  if (editPartner && value !== editPartner.doc) {
                    setIsEditing(false);
                  }
                  if (value !== lastFetchedDoc && value !== editPartner?.doc) {
                    setLastFetchedDoc(value);
                    fetchConjuge(value);
                  }
                }}
                name="doc_conjuge"
                label="CPF *"
                mask="999.999.999-99"
              />
            </div>
            <div className="col-md-3">
              <Input
                name="name_conjuge"
                control={control}
                errors={errors}
                label="Nome completo *"
                type="text"
                isRequired={true}
                validationRules={{
                  validate: (value) => {
                    const nameParts = value.trim().split(/\s+/);
                    if (nameParts.length < 2) {
                      return "Por favor, insira um nome completo.";
                    }
                    const lastName = nameParts[nameParts.length - 1];
                    if (lastName.length <= 2) {
                      return "O sobrenome deve ter mais que 2 caracteres.";
                    }
                    return true;
                  },
                }}
              />
            </div>
            {foundPartner ? (
              <></>
            ) : (
              <>
                <div className="col-md-3">
                  <Input
                    name="rg_conjuge"
                    maxLength={40}
                    errors={errors}
                    control={control}
                    isRequired={inputRequireds?.includes("rg")}
                    label={`RG ${inputRequireds?.includes("rg") ? "*" : ""}`}
                  />
                </div>
                <div className="col-md-3">
                  <CalendarInput
                    name="date_of_birth_conjuge"
                    control={control}
                    errors={errors}
                    isRequired={inputRequireds?.includes("date_of_birth")}
                    label={`Data de Nascimento ${
                      inputRequireds?.includes("date_of_birth") ? "*" : ""
                    }`}
                  />
                </div>
                <div className="col-md-3">
                  <Input
                    name="email_conjuge"
                    control={control}
                    errors={errors}
                    label={`Email ${
                      inputRequireds?.includes("email") ? "*" : ""
                    }`}
                    isRequired={inputRequireds?.includes("email")}
                  />
                </div>
                <div className="col-md-3">
                  <Input
                    name="profession_conjuge"
                    control={control}
                    errors={errors}
                    label={`Profissão ${
                      inputRequireds?.includes("Profissão") ? "*" : ""
                    }`}
                    required={inputRequireds?.includes("Profissão")}
                  />
                </div>
                <div className="col-md-3">
                  <MaskInput
                    control={control}
                    errors={errors}
                    label={`Celular ${
                      inputRequireds?.includes("contacts") ? "*" : ""
                    }`}
                    mask="(99) 99999-9999"
                    name="number_conjuge"
                  />
                </div>
                <div className="col-md-3">
                  <MaskInput
                    control={control}
                    errors={errors}
                    label={`Telefone ${
                      inputRequireds?.includes("contacts") ? "*" : ""
                    }`}
                    mask="(99) 9999-9999"
                    name="tel_conjuge"
                  />
                </div>
                <div className="col-md-3">
                  <Input
                    name="name_mother_conjuge"
                    control={control}
                    errors={errors}
                    label={`Nome da Mãe ${
                      inputRequireds?.includes("name_mother") ? "*" : ""
                    }`}
                    required={inputRequireds?.includes("name_mother")}
                  />
                </div>
                <div className="col-md-3">
                  <Input
                    name="name_father_conjuge"
                    control={control}
                    errors={errors}
                    label={`Nome da Pai ${
                      inputRequireds?.includes("name_father") ? "*" : ""
                    }`}
                    required={inputRequireds?.includes("name_father")}
                  />
                </div>
                <div className="col-md-3">
                  <Input
                    name="issuing_authority_conjuge"
                    control={control}
                    errors={errors}
                    label={`Órgão Expedidor ${
                      inputRequireds?.includes("issuing_authority") ? "*" : ""
                    }`}
                    required={inputRequireds?.includes("issuing_authority")}
                  />
                </div>
                <div className="col-md-3">
                  <Input
                    name="nationality_conjuge"
                    control={control}
                    errors={errors}
                    label={`Nacionalidade ${
                      inputRequireds?.includes("nationality") ? "*" : ""
                    }`}
                    required={inputRequireds?.includes("nationality")}
                  />
                </div>
                <div className="col-md-12 mt-4">
                  <TextareaInput
                    control={control}
                    errors={errors}
                    isRequired={inputRequireds?.includes("obs")}
                    label={`Observação ${
                      inputRequireds?.includes("obs") ? "*" : ""
                    }`}
                    name="obs_conjuge"
                  />
                </div>
              </>
            )}
            <div className="d-flex justify-content-end pt-5">
              {foundPartner ? (
                <>
                  <Button
                    label="Vincular"
                    type="button"
                    loading={loading}
                    disabled={isMaried || typePartner}
                    onClick={() => handleLinkPartner()}
                  />
                </>
              ) : (
                <Button
                  label="Registrar"
                  type="button"
                  loading={loading}
                  disabled={isMaried || typePartner}
                  onClick={() => handleNext(getValues())}
                />
              )}
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
}
